export default {"src":"/_next/static/media/blues-brandmark.96f0c54d.svg","height":1310,"width":1310,"blurWidth":0,"blurHeight":0};